import { RumInit } from '@maersk-global/telemetry-web-sdk';
import { environment } from '../../environments/environment';

let faro: ReturnType<typeof RumInit> | null = null;

export const initializeRum = (): void => {
  const appName = environment.rumConfig.appName;
  const apiKey = environment.rumConfig.apiKey;

  if (!apiKey || !appName) {
    return;
  }

  const env = environment.rumConfig.environment || 'dev';

  faro = RumInit({
    app: {
      environment: env,
      name: appName,
      version: '1.0.0',
    },
    apiKey,
    debug: false,
    traceLog: true,
    useSendBeacon: true,
  });
};

const getTelemetryUserName = (): string => {
  const username: string | null = sessionStorage.getItem('userName');

  if (username && username !== 'unknown') {
    return username;
  }

  return 'unknown';
};

export const setTelemetryUser = (userName: string = getTelemetryUserName()): void => {
  if (!userName || userName === 'unknown' || !faro?.api) {
    return;
  }

  faro.api.setUser({
    id: userName,
  });
};
